import { bufferTime, catchError, filter, mergeMap, share } from 'rxjs/operators';
import { defer, EMPTY, from } from 'rxjs';
import api from '@/service/api';
import ImageProcessingError from '@/model/ImageProcessingError';
import noErrors from './noErrors';
import errorsOnly from './errorsOnly';
import ids$ from './ids';

const uploadTicketWithErrors$ = ids$.pipe(
    bufferTime(150, undefined, 25),
    filter(photos => photos.length > 0),
    mergeMap(photos => {
        const sessions = new Map<string, typeof photos>();
        for (const entry of photos) {
            if (!entry.photo.active) continue;
            const group = sessions.get(entry.photo.sessionId) || [];
            group.push(entry);
            sessions.set(entry.photo.sessionId, group);
        }
        return from(sessions.entries());
    }),
    mergeMap(([sessionId, entries]) => defer(() => api.createUploadTicket(sessionId,
        entries.map(({ id, photo }) => ({ id, sizeInBytes: photo.file.size })),
    )).pipe(
        mergeMap(ticket => from(entries.filter(({ photo }) => photo.active).map(({ id, photo }) => {
            return ticket.data[id]
                ? { ticket: { ...ticket, data: ticket.data[id] }, photo }
                : new ImageProcessingError(photo, new Error(`Missing upload ticket for ${id}`), EMPTY, 'createUploadTicket');
        }))),
        catchError(error => from(entries.filter(({ photo }) => photo.active).map(({ photo }) =>
            new ImageProcessingError(photo, error, EMPTY, 'createUploadTicket'),
        ))),
    ), 2),
    share(),
);

export const uploadTicketErrors$ = uploadTicketWithErrors$.pipe(errorsOnly());
export default uploadTicketWithErrors$.pipe(noErrors());
